import axios from '../../../utils/customAxiosUtil';
import qs from 'qs';
import {
  BasFlightAprovData,
  FlightPlanAreaData,
  FlightPlanAreaDataList,
  FlightPlanData,
  FlightPlanListRqData,
  FlightUamBufferRq,
  weatherData
} from '../models/basisFlightModel';

export const flightPlanAPI = {
  area: async () => {
    const res = await axios.get(`api/bas/flight/area`);
    return res;
  },
  list: async (data: FlightPlanListRqData) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    const res = await axios.get(`api/bas/flight/plan/list${queryString}`);
    return res;
  },
  detail: async (planSno: number) => {
    const res = await axios.get(`api/bas/flight/plan/detail/${planSno}`);
    return res;
  },
  create: async (data: FlightPlanData) => {
    const res = await axios.post(`api/bas/flight/plan/create`, data);
    return res;
  },
  update: async (data: FlightPlanData) => {
    const res = await axios.put(`api/bas/flight/plan/update`, data);
    return res;
  },
  delete: async (planSno: number) => {
    const res = await axios.delete(`api/bas/flight/plan/delete/${planSno}`);
    return res;
  },
  listPilot: async (groupId: string) => {
    const res = await axios.get(`api/bas/flight/plan/pilot/${groupId}`);
    return res;
  },
  listArcrft: async (groupId: string) => {
    const res = await axios.get(`api/bas/flight/plan/arcrft/${groupId}`);
    return res;
  },
  listBuffer: async (data: FlightPlanAreaDataList) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'brackets'
    });
    const res = await axios.post(`api/bas/flight/plan/area/buffer`, data);
    return res;
  },
  apiweather: async (rq: weatherData) => {
    const { data } = await axios.get(`api/bas/flight/plan/api/weather`, {
      params: {
        ...rq
      }
    });
    return data;
  },
  aprvList: async (data: FlightPlanListRqData) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    const res = await axios.get(`api/bas/flight/aprv/list${queryString}`);
    return res;
  },
  aprvProc: async (data: BasFlightAprovData) => {
    const res = await axios.put(`api/bas/flight/aprv/proc`, data);
    return res;
  },

  searchArea: async param => {
    return await axios.get(
      `api/bas/flight/plan/area/search?query=${param.query}`
    );
  },
  scheduleList: async (date: string) => {
    return await axios.get(`api/bas/flight/schedule?searchDate=${date}`);
  },
  uamBufferList: async (data: FlightUamBufferRq) => {
    return await axios.post('/api/bas/flight/adex/buffer', data);
  }
};
